import React, { useEffect, useState } from 'react'
import "./styles/CreateProjectButton.scss";
import buttonIcon from "./img/edit-icon.svg";
import { FormattedMessage } from 'react-intl';
import proquinalHistory from 'services/browser-history';
import { graphql, compose } from 'react-apollo';
import meQuery from 'utils/queries/MeQuery';
import useMediaQuery from 'utils/hooks/useMediaQuery';
import classNames from 'classnames';
import { LG } from 'constants/breakpoints';

const CreateProjectButton = ({ meQuery }) => {
  const { me } = meQuery;
  const [hiddenText, setHiddenText] = useState(false);
  const isMobile = useMediaQuery(LG)

  const goToCreateProject = () => 
    proquinalHistory.push({ 
      pathname: '/project/creation-form'
    });

  useEffect(() => {
    const timer = setTimeout(() => {
      setHiddenText(true);
    }, 3000);

    const handleScroll = () => {
      if (window.scrollY !== 0) setHiddenText(true);
    };

    window.addEventListener("scroll", handleScroll);
  return () => {
    clearTimeout(timer);
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  return me?.hasCreateProjectAccess ? (
    !isMobile ? (
      <button className="create_project-btn" onClick={goToCreateProject}>
        <img
          src={buttonIcon}
          alt="create-project-icon"
          className="create_project-btn__icon"
        />
        <FormattedMessage
          id="CreateProjectButton.createProject"
          defaultMessage="Create Project"
        />
      </button>
    ) : (
      <div className="create_project-btn--wrapper" onClick={goToCreateProject}>
        <button className="create_project-btn--mobile">
          <img
            src={buttonIcon}
            alt="create-project-icon"
            className="create_project-btn__mobile-icon"
          />
        </button>

        <span className={classNames({
          "create_project-btn__mobile-text": true,
          "create_project-btn__mobile-text--hidden": hiddenText
        })}>
          <FormattedMessage
            id="CreateProjectButton.createProject"
            defaultMessage="Create Project"
          />
        </span>
      </div>
    )
  ) : null;
}

export default compose(
  graphql(meQuery, {
    name: "meQuery"
  })
)(CreateProjectButton);
